//
//
//
//
//

import uiCrop from '@/component/uiCrop'

export default {
  components: {
    uiCrop
  },
  data () {
    return {
      img: 'static/img/71X58PICNjx_1024.jpg',
      panel: true,
      picValue: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/demo/cropDemo.vue